import { gql } from '@apollo/client';

const CompanyBasicSettingsFragment = gql`
  fragment CompanyBasicSettingsFields on CompanyBasicSettingsResult {
    companyId
    visibility
  }
`;

export default CompanyBasicSettingsFragment;
